import { style } from '@vanilla-extract/css';

export const container = style({
  padding: 'var(--wt-padding)',
  borderTop: '2px solid color-mix(in srgb, var(--site-theme-text-on-background-color) 10%, transparent)',
});
